type JSONValues = string | number | boolean | null | { [key: string]: JSONValues } | JSONValues[]

export const parse = (json: string): JSONValues =>
	JSON.parse(json.replace(/:\s*([-\d]{16,})(?=[\s,}\]])/g, (_, num) => `: "${num}"`))
